var _react_refresh_temp_1, _react_refresh_temp_2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FloatingBox, Separator } from '@lucidlink/uicore';
import { HelpCenterMenuItem, SubmitFeedbackMenuItem, SubmitSupportRequestMenuItem, SupportMenuContentContainer, SupportMenuTrigger, } from '@lucidlink/workspacemanagement';
const SupportMenuContent = () => (_jsxs(SupportMenuContentContainer, { children: [_jsx(SubmitSupportRequestMenuItem, {}), _jsx(HelpCenterMenuItem, {}), _jsx(Separator, {}), _jsx(SubmitFeedbackMenuItem, {})] }));
_react_refresh_temp_1 = SupportMenuContent;
$RefreshReg$(_react_refresh_temp_1, "SupportMenuContent");
export const SupportMenu = () => (_jsx(FloatingBox, { Content: _jsx(SupportMenuContent, {}), "data-testid": "support-menu", renderTrigger: SupportMenuTrigger }));
_react_refresh_temp_2 = SupportMenu;
$RefreshReg$(_react_refresh_temp_2, "SupportMenu");
